module.exports = __webpack_public_path__ + "static/media/battery-half.aa513c68.svg";